'use strict';

import searchTrackingService from '../../Shared/search-tracking-service.js';

const mobileSearchModule = (() => {
    const modal = document.getElementById('searchMobileModal');

    const initSearchBoxRotation = () => {
        if (!AppSettings.shouldPromoteTextualSearch) return;

        const vm = AppSettings.textualSearchViewModel;
        const placeholders = [
            AppSettings.searchPlaceHolder,
            vm?.resources?.searchPlaceHolder1,
            vm?.resources?.searchPlaceHolder2,
            vm?.resources?.searchPlaceHolder3
        ].filter(Boolean);

        if (placeholders.length <= 1) return;

        const elements = [
            document.querySelector('.searchbox-mobile__input p'),
            document.querySelector('.search-bar-btn__label')
        ].filter(Boolean);

        if (elements.length === 0) return;

        let index = 0;
        const interval = vm?.resources?.placeholderRotationInterval || 3000;
        setInterval(() => {
            index = (index + 1) % placeholders.length;
            elements.forEach(el => { el.textContent = placeholders[index]; });
        }, interval);
    };

    if (typeof AppSettings !== 'undefined') {
        initSearchBoxRotation();
    } else {
        document.addEventListener('DOMContentLoaded', initSearchBoxRotation);
    }

    if (!modal) return { showModal: () => { }, closeModal: () => { } };

    const showModal = () => {
        searchTrackingService.trackHeaderInteract();

        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('data-state', 'visible');
        document.body.classList.add('search-modal-noscroll');

        const handleAnimationEnd = (event) => {
            if (event.target === modal && event.animationName === 'search-modal-in') {
                const searchField = document.getElementById('searchMobileModal-autocomplete-input');
                if (searchField) {
                    searchField.focus();
                }
                modal.removeEventListener('animationend', handleAnimationEnd);
            }
        };

        modal.addEventListener('animationend', handleAnimationEnd);
    };

    const closeModal = () => {
        modal.setAttribute('data-state', 'closing');

        const handleAnimationEnd = (event) => {
            if (event.target === modal && event.animationName === 'search-modal-out') {
                modal.setAttribute('data-state', 'hidden');
                modal.setAttribute('aria-modal', 'false');
                document.body.classList.remove('search-modal-noscroll');
                modal.removeEventListener('animationend', handleAnimationEnd);
            }
        };

        modal.addEventListener('animationend', handleAnimationEnd);
    };

    return { showModal, closeModal };
})();

// TODO: Refactor cshtml inline onclick handlers to use event listeners, then remove this global assignment
window.mobileSearchModule = mobileSearchModule;
